<template>
  <div class="materials-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="组织">
              <el-select v-model="searchForm.group" style="width: 120px" @change="Search" filterable>
                <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name"
                  :value="item.groupid" />
              </el-select>
            </el-form-item>
            <el-form-item label="门店标配">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option label="标配" :value="1" />
                <el-option label="非标配" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button-group>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="editRow(null)">添加物料</el-button>
                <el-button size="small" icon="el-icon-s-home" @click="operateStock(1)">入库</el-button>
                <el-button size="small" icon="el-icon-s-promotion" @click="operateStock(0)">出库</el-button>
                <el-button icon="el-icon-document" size="small" @click="exportExcel">导出Excel</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              row-key="material_id"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
              style="width: 100%"
            >
              <el-table-column
                fixed
                prop="material_name"
                label="物料名称"
                show-overflow-tooltip
                min-width="160"
              >
              </el-table-column>
              <el-table-column
                prop="img"
                align="center"
                label="图片"
                width="100"
              >
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.img"
                    style="width: 80px; height: 80px"
                    :src="scope.row.img"
                    fit="contain"
                    :preview-src-list="[scope.row.img]"
                  >
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="brand_name"
                align="center"
                label="品牌"
                show-overflow-tooltip
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="spec"
                align="center"
                label="规格"
                show-overflow-tooltip
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop="wranning"
                align="center"
                show-overflow-tooltip
                label="预警线"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="unit"
                label="单位"
                align="center"
                show-overflow-tooltip
                width="90"
              >
              </el-table-column>
              <el-table-column
                prop="cost"
                label="成本单价"
                align="center"
                show-overflow-tooltip
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="price"
                show-overflow-tooltip
                label="对外单价"
                align="center"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="time"
                label="时间"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.time">{{ scope.row.time.slice(0, 11) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                width="180"
                show-overflow-tooltip
                label="备注"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="门店标配"
                fixed="right"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.is_standard===1" :disable-transitions="true" size="mini">标配 {{ scope.row.standard }}</el-tag>
                  <el-tag v-if="scope.row.is_standard!==1" :disable-transitions="true" type="info" size="mini">非标配</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                fixed="right"
                align="center"
                label="库存"
                width="90"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.stock>0" style="font-weight: 500;color:#409EFF">{{ scope.row.stock }}</span>
                  <span v-if="scope.row.stock<0" style="font-weight: 500;color:#f56c6c">{{ scope.row.stock }}</span>
                  <span v-if="scope.row.stock==0" style="font-weight: 500;color:#909399">0</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                align="center"
                show-overflow-tooltip
                label="操作"
                width="180"
              >
                <template slot-scope="scope">
                  <el-button size="mini" icon="el-icon-edit-outline" @click="editRow(scope.row)">编辑</el-button>
                  <el-button size="mini" icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle===0?'添加物料':'修改物料'"
      :visible.sync="editDialog"
      width="40%"
      :destroy-on-close="true"
      :append-to-body="true"
      :lock-scroll="true"
      :before-close="handleClose"
    >
      <el-form ref="editForm" size="small" :model="editForm" label-width="80px" :rules="rules">
        <el-form-item label="选择品牌" prop="brandId">
          <el-select v-model="editForm.brandId" filterable placeholder="请选择品牌">
            <el-option v-for="item in editForm.brandList" :key="item.brand_id" :label="item.brand_name" :value="item.brand_id" />
          </el-select>
        </el-form-item>
        <el-form-item label="上级物料" prop="pid">
          <el-select
            v-model="editForm.pid"
            style="width: 100%;"
            :disabled="!!editForm.hasChildren"
            filterable
            placeholder="请选择上级物料"
            @change="parentMaterialChange"
          >
            <el-option
              v-for="item in editForm.materialList"
              :key="item.material_id"
              :disabled="!!editTitle && editTitle == item.material_id"
              :label="item.material_name"
              :value="item.material_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="物料名称" prop="name">
          <el-input v-model="editForm.name" show-word-limit maxlength="100" />
        </el-form-item>
        <el-form-item label="物料图片" prop="img">
          <SingleImg v-model="editForm.imgObj" :oldurl="editForm.img" />
        </el-form-item>
        <el-form-item label="规格" prop="space">
          <el-input v-model="editForm.space" show-word-limit maxlength="50" />
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input v-model="editForm.unit" style="width: 200px" maxlength="10" />
        </el-form-item>
        <el-form-item label="预警线" prop="warning">
          <el-input-number v-model="editForm.warning" :min="0" :max="999999"></el-input-number>
        </el-form-item>
        <el-form-item label="成本单价" prop="cost">
          <el-input v-model="editForm.cost" style="width: 200px" oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="对外单价" prop="price">
          <el-input v-model="editForm.price" style="width: 200px" oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="门店标配" prop="isStandard">
          <el-radio-group v-model="editForm.isStandard">
            <el-radio :label="0">非标配</el-radio>
            <el-radio :label="1">标配</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="editForm.isStandard===1" label="标配数量" prop="standard">
          <el-input-number v-model="editForm.standard" :min="0" :max="99999999999"></el-input-number>
        </el-form-item>
        <el-form-item label="上传时间" prop="time">
          <el-date-picker
            v-model="editForm.time"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd hh:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="editForm.remark"
            type="textarea"
            placeholder="请输入备注"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button :loading="btnLoading" type="primary" @click="subEditMaterial('editForm')">立即提交</el-button>
          <el-button @click="editDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="stockTitle===0?'出库':'入库'"
      :visible.sync="stockDialog"
      width="40%"
      :before-close="handleClose"
    >
      <el-form ref="stockForm" v-loading="stockFormLoading" size="small" :model="stockForm" label-width="90px" :rules="rules">
        <el-form-item label="请选择物料" prop="index">
          <el-select v-model="stockForm.mid" style="width: 100%;" placeholder="请选择物料" filterable>
            <template v-for="item in stockForm.materialList">
              <el-option-group
                v-if="item.children && item.children.length > 0"
                :key="item.material_id"
                :label="item.material_name"
              >
                <el-option
                  v-for="child in item.children"
                  :key="child.material_id"
                  :label="child.material_name + ' ' + child.material_spce"
                  :value="child.material_id"
                >
                  <span style="float: left">{{ child.material_name }} {{ child.material_spce }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ child.brand_name || child.brandName }}</span>
                </el-option>
              </el-option-group>
              <el-option-group v-if="item.children && item.children.length > 0" :key="'line'+item.material_id"></el-option-group>
              <el-option
                v-else
                :key="item.material_id"
                :label="item.material_name"
                :value="item.material_id"
              >
                <span style="float: left">{{ item.material_name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.brand_name }}</span>
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="num">
          <el-input-number v-model="stockForm.num" :min="1" :max="999999"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="stockForm.remark"
            type="textarea"
            placeholder="请输入备注"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button :loading="btnLoading" type="primary" @click="subStock('stockForm')">立即提交</el-button>
          <el-button @click="stockDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getMaterialManagerList, delMaterial, getMaterialInfo, addOrEditMaterial, materialStorage, exportMaterialsExcel } from '@/api/work'
import { getUserWorkRule } from '@/api/user'
import SingleImg from '@/components/upload/SingleImg'

import {
  getGroupReport
} from '@/api/pub'

export default {
  components: {
    SingleImg
  },
  data() {
    return {
      searchForm: {
        group: '',
        search: '',
        type: ''
      },
      loading: false,
      editFormLoading: false,
      selectStock: 0,
      stockFormLoading: false,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      total: 0,
      editDialog: false,
      stockDialog: false,
      btnLoading: false,
      editTitle: 0,
      stockTitle: 0,
      editFormCopy: {},
      editForm: {
        name: '',
        brand: '',
        brandId: '',
        pid: '',
        space: '',
        warning: '',
        isStandard: 0,
        standard: '',
        cost: '',
        price: '',
        unit: '',
        time: '',
        remark: '',
        brandList: []
      },
      stockForm: {
        mid: '',
        index: '',
        num: '',
        remark: '',
        materialList: []
      },
      rules: {
        name: [{ required: true, message: '请输入物料名称', trigger: 'blur' }],
        brandId: [{ required: true, message: '请输入选择品牌', trigger: 'change' }],
        mid: [{ required: true, message: '请选择物料', trigger: 'change' }],
        num: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        standard: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        warning: [{ required: true, message: '请输入预警数量', trigger: 'blur' }],
        cost: [{ required: true, message: '请输入成本单价', trigger: 'blur' }],
        price: [{ required: true, message: '请输入对外单价', trigger: 'blur' }]
      },
      isMenu: 0,

      groupList: [],
    }
  },
  computed: {
    user: getUser
  },
  created() {
    // this.getMenu()
    this.editFormCopy = Object.assign(this.editFormCopy, this.editForm)
    this.searchForm.group = this.user.dGroupid
    this.getGroupList()
    this.getMaterialsData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getMaterialsData()
    },
    getGroupList() {
      getGroupReport().then(response => {
        const arr = []
        for (const item of response.data) {
          if (item.nature === 0) {
            arr.push(item)
          }
        }
        this.groupList = arr
      })
    },
    getMenu() {
      const data = {
        userid: this.user.dUserid,
        rule: this.user.rank,
        type: 0
      }
      getUserWorkRule(data).then(response => {
        for (const m of response.data) {
          if (m.name === '企划物料') {
            for (const menu of m.menulst) {
              if (menu.dNum === 'wlzl') {
                this.isMenu = 1
                break
              }
            }
            break
          }
        }
        this.getMaterialsData()
      })
    },
    getMaterialsData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        content: this.searchForm.search,
        mark: this.searchForm.type,
        groupid: this.searchForm.group,
        isMenu: this.isMenu
      }
      getMaterialManagerList(data).then(response => {
        this.tableData = response.data || []
        // 子数据
        this.tableData.forEach(r => {
          if (r.children && r.children.length > 0) {
            r.children.forEach(child => {
              child.spec = child.material_spce
              child.brand_name = child.brandName
              child.stock = child.instock
              child.wranning = child.wraning
            })
          }
        })
        this.total = response.total
        this.loading = false
      })
    },
    loadChildren(tree, treeNode, resolve) {
      const data = {
        page: 1,
        limit: 999,
        pid: tree.material_id,
        groupid: this.searchForm.group,
        isMenu: this.isMenu
      }
      getMaterialManagerList(data).then(response => {
        resolve(response.data || [])
      })
    },

    parentMaterialChange(val) {
      const material = this.editForm.materialList.find((item) => item.material_id === val)
      if (material) {
        this.editForm.brand = material.brand_name
        this.editForm.brandId = material.brand_id
        this.editForm.warning = material.wranning
        this.editForm.isStandard = material.is_standard
        this.editForm.cost = material.cost
        this.editForm.price = material.price
        this.editForm.unit = material.unit
        this.editForm.img = material.img
        this.editForm.imgObj = { imgurl: material.img }
      }
    },

    editRow(row) {
      this.editFormLoading = true
      if (row !== null) {
        this.editTitle = row.material_id
        this.editForm.hasChildren = row.children && row.children.length > 0
      } else {
        this.editTitle = 0
        this.editForm.hasChildren = false
      }
      this.editForm.img = ''
      this.editDialog = true
      getMaterialInfo({ mid: this.editTitle, groupid: this.searchForm.group, isMenu: this.isMenu }).then(response => {
        if (row !== null) {
          this.editForm.name = response.data.materialsInfo.material_name
          this.editForm.img = response.data.materialsInfo.img
          this.editForm.imgObj = { imgurl: response.data.materialsInfo.img }
          this.editForm.brand = response.data.materialsInfo.brand_name
          this.editForm.space = response.data.materialsInfo.spec
          this.editForm.warning = response.data.materialsInfo.wranning
          this.editForm.isStandard = response.data.materialsInfo.is_standard
          this.editForm.standard = response.data.materialsInfo.standard
          this.editForm.cost = response.data.materialsInfo.cost
          this.editForm.price = response.data.materialsInfo.price
          this.editForm.unit = response.data.materialsInfo.unit
          this.editForm.remark = response.data.materialsInfo.remark
          this.editForm.brandId = response.data.materialsInfo.brand_id
          this.editForm.time = response.data.materialsInfo.time
          this.editForm.pid = response.data.materialsInfo.pid || ''
        } else {
          this.editForm = Object.assign(this.editForm, this.editFormCopy)
        }
        this.editForm.brandList = response.data.brandList
        this.editFormLoading = false
        this.$forceUpdate()
      })
      const data = {
        page: 1,
        limit: 9999,
        groupid: this.searchForm.group,
        isMenu: this.isMenu
      }
      getMaterialManagerList(data).then(response => {
        this.editForm.materialList = response.data || []
        this.editFormLoading = false
        this.$forceUpdate()
      })
    },
    deleteRow(row) {
      this.$confirm('您确定要删除这个物料吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delMaterial({ mid: row.material_id }).then(response => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getMaterialsData()
        })
      }).catch(() => {

      })
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getMaterialsData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getMaterialsData()
    },
    operateStock(val) {
      this.stockTitle = val
      this.stockDialog = true
      this.stockFormLoading = true
      this.stockForm.remark = ''
      this.stockForm.num = ''
      this.stockForm.mid = ''
      const data = {
        page: 1,
        limit: 99999999,
        groupid: this.searchForm.group,
        isMenu: this.isMenu
      }
      getMaterialManagerList(data).then(response => {
        const list = response.data || []
        const materialList = response.data || []
        // list.forEach(r => {
        //   if (r.children && r.children.length > 0) {
        //     r.children.forEach(c => {
        //       c.pname = r.material_name
        //       c.spec = c.material_spce
        //       c.brand_name = c.brandName
        //       c.stock = c.instock
        //       c.wranning = c.wraning
        //       materialList.push(c)
        //     })
        //   } else {
        //     materialList.push(r)
        //   }
        // })
        this.stockForm.materialList = materialList
        this.stockFormLoading = false
      })
    },
    handleClose(done) {
      done()
    },
    subEditMaterial(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          const data = {
            pid: this.editForm.pid,
            brandid: this.editForm.brandId,
            name: this.editForm.name,
            img: (this.editForm.imgObj || {}).img_url,
            spec: this.editForm.space,
            unit: this.editForm.unit,
            wraning: this.editForm.warning,
            cost: this.editForm.cost,
            price: this.editForm.price,
            isstandard: this.editForm.isStandard,
            standard: this.editForm.standard,
            remark: this.editForm.remark,
            time: this.editForm.time,
            mid: this.editTitle
          }
          addOrEditMaterial(data).then(response => {
            this.editDialog = false
            this.$message({
              message: '物料信息提交成功',
              type: 'success'
            })
            this.btnLoading = false
            this.getMaterialsData()
          })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    subStock(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          const data = {
            userid: this.user.dUserid,
            mid: this.stockForm.mid,
            remark: this.stockForm.remark,
            num: this.stockForm.num,
            type: this.stockTitle
          }
          materialStorage(data).then(response => {
            if (this.stockTitle === 0) {
              this.$message({
                message: '物料出库成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: '物料入库成功',
                type: 'success'
              })
            }
            this.stockForm.mid = ''
            this.stockForm.num = ''
            this.stockForm.remark = ''
            this.stockDialog = false
            this.btnLoading = false
            this.getMaterialsData()
          }).catch(() => {
            this.btnLoading = false
          })
        } else {
          return false
        }
      })
    },
    exportExcel() {
      const data = {
        content: this.search,
        mark: this.type,
        groupid: this.searchForm.group,
        isMenu: this.isMenu
      }
      this.$message({
        message: '数据正在导出，请稍候...',
        type: 'success'
      })
      exportMaterialsExcel(data).then(response => {
        const _this = this
        const xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            const blob = this.response
            const a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.materials {
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.tcf-row{
  .card{
    .card-body{
      .card-title{
        font-weight: 500;
        color: #404852;
        margin-bottom: 22px;
        font-size: 14px;
        .search-mode{
          width: 300px;
          position: relative;
          float: right;
          margin-top: -10px;
          .search-input{
            background-color: #F2F6FC;
            border:0;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            color: #606266;
            padding: 0 40px 0 15px;
            -webkit-appearance: none;
            font-size: 12px;
            width: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            &::-webkit-input-placeholder {
              color: #C0C4CC;
            }
            &::-ms-input-placeholder {
              color: #C0C4CC;
            }
          }
          .search-btn{
            position: absolute;
            right: 0;
            height: 40px;
            width: 40px;
            line-height: 40px;
            top: 0;
            border: 0;
            background: transparent;
            text-align: center;
            padding: 0;
          }
        }
      }
      .card-content{
        .group-filter{
          width: 100%;
          padding: 0 30px 0 0 ;
          margin: 0 ;
          position: relative;
          li{
            width: 100%;
            list-style: none;
            position: relative;
            padding-left: 20px;
            padding-top: 15px;
            padding-bottom: 15px;
            cursor: pointer;
            border-radius: 2px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &.active{
              background: #f5f7fa;
              color:#409EFF;
            }
            &:hover{
              color:#409EFF;
            }
          }
        }
        .client-sex{
          width: 16px!important;
          height: 16px!important;
          vertical-align: -4px!important;
        }
        .el-table::before{
          height: 0!important;
        }
        .el-pagination{
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
